module.exports = __webpack_public_path__ + "static/media/ejkcard.34125e50.png";